import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalCounselListComponent } from './legal-counsel-list/legal-counsel-list.component';
import { LegalCounselEditComponent } from './legal-counsel-edit/legal-counsel-edit.component';
import { AngularMaterialModule } from '../angular-material.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AclDataModule } from '../acl-data/acl-data.module';



@NgModule({
  declarations: [LegalCounselListComponent, LegalCounselEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    RouterModule.forChild([]),
    AclDataModule
  ]
})
export class LegalCounselModule { }
